/**
 * Actions misceláneos y de utilidad
 */

/**
 * Establece el estado de registro
 */
export const setStatus = async ({ commit }) => {
    try {
        commit('SET_LOADING', true);
        commit('SET_REGISTRATION', null);
    } catch (err) {
        commit('SET_LOADING', false);
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    }
};

/**
 * Establece el registro
 */
export const setRegistration = async ({ commit }) => {
    try {
        commit('SET_LOADING', true);
        commit('SET_REGISTRATION', null);
    } catch (err) {
        commit('SET_LOADING', false);
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    }
};

/**
 * Llama al código celular
 */
export const callCellularCode = async ({ commit }) => {
    try {
        commit('SET_LOADING', true);
        commit('SET_REGISTRATION', null);
    } catch (err) {
        commit('SET_LOADING', false);
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    }
};
